module.exports = __webpack_public_path__ + "media/newstyle/images/img-footer-es-40cee53874273fbe9c1cc6b6a19d1596.svg";